import React, { useState, useEffect } from 'react';
import { participantService } from '../services/participantService';
import './ParticipantSelectionModal.css';

const ParticipantSelectionModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  maxParticipants = null,
  eventType = null 
}) => {
  const [participants, setParticipants] = useState([]);
  const [selectedParticipants, setSelectedParticipants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      loadParticipants();
    }
  }, [isOpen]);

  const loadParticipants = async () => {
    try {
      setLoading(true);
      const data = await participantService.getParticipants();
      setParticipants(data);
      setError('');
    } catch (err) {
      setError('Erro ao carregar participantes');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleParticipantToggle = (participantId) => {
    setSelectedParticipants(prev => {
      if (prev.includes(participantId)) {
        return prev.filter(id => id !== participantId);
      } else {
        if (maxParticipants && prev.length >= maxParticipants) {
          setError(`Pode selecionar no máximo ${maxParticipants} participante(s)`);
          return prev;
        }
        setError('');
        return [...prev, participantId];
      }
    });
  };

  const handleConfirm = () => {
    if (selectedParticipants.length === 0) {
      setError('Por favor, selecione pelo menos um participante');
      return;
    }

    const selectedData = participants.filter(p => 
      selectedParticipants.includes(p.id)
    );
    onConfirm(selectedData);
    handleClose();
  };

  const handleClose = () => {
    setSelectedParticipants([]);
    setError('');
    onClose();
  };

  const getParticipantTypeLabel = (type) => {
    return type === 'Child' || type === 0 ? 'Criança' : 'Adulto';
  };

  const getParticipantAge = (birthDate) => {
    const today = new Date();
    const birth = new Date(birthDate);
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
    return age;
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content participant-selection-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Selecionar Participantes</h2>
          <button className="modal-close" onClick={handleClose}>&times;</button>
        </div>

        <div className="modal-body">
          {loading ? (
            <div className="loading-state">A carregar participantes...</div>
          ) : participants.length === 0 ? (
            <div className="empty-state">
              <p>Ainda não tem participantes registados.</p>
              <p>Por favor, registe participantes primeiro na página "Meus Participantes".</p>
            </div>
          ) : (
            <>
              {maxParticipants && (
                <div className="info-message">
                  Pode selecionar até {maxParticipants} participante(s)
                </div>
              )}

              {error && (
                <div className="error-message">
                  {error}
                </div>
              )}

              <div className="participants-list">
                {participants.map(participant => (
                  <div 
                    key={participant.id} 
                    className={`participant-item ${selectedParticipants.includes(participant.id) ? 'selected' : ''}`}
                    onClick={() => handleParticipantToggle(participant.id)}
                  >
                    <div className="participant-checkbox">
                      <input
                        type="checkbox"
                        checked={selectedParticipants.includes(participant.id)}
                        onChange={() => {}}
                        onClick={e => e.stopPropagation()}
                      />
                    </div>
                    
                    <div className="participant-details">
                      <div className="participant-name-row">
                        <h4>{participant.nome}</h4>
                        <span className={`type-badge ${participant.type === 'Child' || participant.type === 0 ? 'child' : 'adult'}`}>
                          {getParticipantTypeLabel(participant.type)}
                        </span>
                      </div>
                      
                      <div className="participant-info-row">
                        <span className="info-item">
                          <strong>Idade:</strong> {getParticipantAge(participant.dataNascimento)} anos
                        </span>
                        <span className="info-item">
                          <strong>CC:</strong> {participant.cartaoCidadao}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn-cancel" onClick={handleClose}>
            Cancelar
          </button>
          <button 
            className="btn-confirm" 
            onClick={handleConfirm}
            disabled={selectedParticipants.length === 0}
          >
            Confirmar ({selectedParticipants.length})
          </button>
        </div>
      </div>
    </div>
  );
};

export default ParticipantSelectionModal;